/* eslint-disable global-require */
module.exports = ['events.list.filters.dates.from', 'marketplace.auction._show.html.m53'];
